<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 21C22 21 15.3077 21 2 21L22 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M11.8176 9.04094H10.7741C6.6002 9.04094 3.46957 12.4048 3 17H21C20.5304 12.4949 17.035 9.04094 12.8611 9.04094H11.8176ZM11.8176 9.04094L11.374 8.16246V7.26143V6.0901H10.3566H9.88706V6H13.6436V6.0901H13.174H12.1566V7.26143V8.16246L11.8176 9.04094Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
